import type { IConfig } from '@/types/common';

export const configMap = {
  // 开发
  development: {
    rootPath: 'https://api-dev2.hoby.chat',
    realEnv: 'development',
    host: 'https://web-hy-dev.hoby.live',
    hobyWebHost: 'https://web-react-dev.hoby.live', // 旧项目host地址
    hobyWebHostRu: 'https://web-react-dev.hobychat.ru', // 旧项目host地址（因为s3域名解析问题，俄罗斯使用单独的域名）
    proxyHost: 'https://web-react.thechatie.com'
  },
  // 测试
  testing: {
    rootPath: 'https://api-test.hoby.chat',
    realEnv: 'testing',
    host: 'https://web-hy-test.hoby.live',
    hobyWebHost: 'https://web-react-test.hoby.live', // 旧项目host地址
    hobyWebHostRu: 'https://web-react-test.hobychat.ru', // 旧项目host地址（因为s3域名解析问题，俄罗斯使用单独的域名）
    proxyHost: 'https://web-react.thechatie.com'
  },
  // 灰度
  uat: {
    rootPath: 'https://api-gray2.hoby.chat',
    realEnv: 'testing',
    host: 'https://web-hy-uat.hoby.live',
    hobyWebHost: 'https://web-react-uat.hoby.live', // 旧项目host地址
    hobyWebHostRu: 'https://web-react-uat.hobychat.ru', // 旧项目host地址（因为s3域名解析问题，俄罗斯使用单独的域名）
    proxyHost: 'https://web-react.thechatie.com'
  },
  production: {
    rootPath: 'https://api-web.hoby.chat',
    rootPtahBackup: 'https://api.chatie.live', // 备用api地址
    realEnv: 'production',
    host: 'https://web-hy.hoby.chat',
    hobyWebHost: 'https://web-react.hoby.live', // 旧项目host地址
    hobyWebHostRu: 'https://web-react.hobychat.ru', // 旧项目host地址（因为s3域名解析问题，俄罗斯使用单独的域名）
    proxyHost: 'https://web-react.thechatie.com'
  },
  // vocaChat 环境
  // test 环境
  vocaTesting: {
    rootPath: 'https://api-test.hoby.chat',
    realEnv: 'vocaTesting',
    host: 'https://web-hy-test.vocachat.live',
    hobyWebHost: 'https://web-react-test.vocachat.live', // 旧项目host地址
  },
  vocaProd: {
    rootPath: 'https://api.vocachat.live',
    realEnv: 'vocaProd',
    host: 'https://web-hy.vocachat.live',
    hobyWebHost: 'https://web-react.vocachat.live', // 旧项目host地址
  },
};

type Environment = 'development' | 'testing' | 'uat' | 'production';
const NODE_ENV: Environment = import.meta.env.MODE as Environment;

export function getConfig(env?: 'development' | 'testing' | 'uat' | 'production'): IConfig {
  const config = configMap[env || NODE_ENV] || configMap['production'];
  const defaultConfig = {
    language: 'en',
    designWidth: 375,
    projectName: 'hybrid',
    contactServiceTel: '+1(332)276-3365',
    rootPathRu: 'https://api.hobychat.ru', // 因为s3域名解析问题，俄罗斯使用单独的域名
    rootPtahBackup2: 'https://api.turing.app', // 备用api地址2
  };

  return Object.assign(defaultConfig, config);
}